import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const apiGetCompanyById= (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.COMPANIES.GET_COMPANIES_BY_ID,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
